import React, { useState, useEffect } from "react";
import { FiX, FiFolder } from "react-icons/fi";
import "./EmailMoveModal.css";

const EmailMoveModal = ({ email, onClose, onMove, showToast, labels }) => {
  const [selectedLabel, setSelectedLabel] = useState("");
  const [moving, setMoving] = useState(false);

  // Filter labels to show user-created labels and common Gmail labels
  const userLabels = labels ? labels.filter(label => 
    label.type === "user" || 
    ["INBOX", "SPAM", "TRASH", "STARRED", "IMPORTANT"].includes(label.id)
  ) : [];

  const handleMove = async () => {
    if (!selectedLabel) {
      showToast?.("Please select a label", "error");
      return;
    }

    setMoving(true);
    try {
      // Determine which labels to remove and add
      const currentLabels = email.labelIds || [];
      const removeLabelIds = currentLabels.filter(id => 
        id !== "SENT" && id !== "DRAFT" && id !== "UNREAD"
      );
      
      await onMove({
        messageId: email.id,
        addLabelIds: [selectedLabel],
        removeLabelIds,
      });
      
      showToast?.("Email moved successfully", "success");
      onClose();
    } catch (error) {
      console.error("Error moving email:", error);
      showToast?.("Failed to move email", "error");
    } finally {
      setMoving(false);
    }
  };

  if (!email) return null;

  return (
    <div className="email-move-modal-overlay" onClick={onClose}>
      <div className="email-move-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-move-modal-header">
          <h3>Move Email</h3>
          <button className="close-button" onClick={onClose} title="Close">
            <FiX size={20} />
          </button>
        </div>

        <div className="email-move-modal-body">
          <p className="move-description">
            Select a label to move this email to:
          </p>

          <div className="labels-list">
            {userLabels.length === 0 ? (
              <p className="no-labels">Loading labels...</p>
            ) : (
              userLabels.map((label) => (
                <label key={label.id} className="label-item">
                  <input
                    type="radio"
                    name="label"
                    value={label.id}
                    checked={selectedLabel === label.id}
                    onChange={(e) => setSelectedLabel(e.target.value)}
                    disabled={moving}
                  />
                  <span className="label-name">
                    <FiFolder size={14} style={{ color: `#${label.color?.backgroundColor || "999"}` }} />
                    {label.name}
                  </span>
                </label>
              ))
            )}
          </div>
        </div>

        <div className="email-move-modal-footer">
          <button className="cancel-button" onClick={onClose} disabled={moving}>
            Cancel
          </button>
          <button className="move-button" onClick={handleMove} disabled={moving || !selectedLabel}>
            <FiFolder /> {moving ? "Moving..." : "Move"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailMoveModal;

